import { LocalDateTime, Maybe } from "@flockcover/flock-svc-core-types"
import { UUID } from "io-ts-types/lib/UUID"
import { Analytics } from "../types"
import { TripVehicle } from "../vehicles"

export type TripAnalytics = Analytics & { unsafeMiles: Maybe<number>; safeMiles: Maybe<number> }

export type Trip = {
  analytics: TripAnalytics
  finishedAt: LocalDateTime
  id: UUID
  startedAt: LocalDateTime
  vehicle: TripVehicle
}

export type TripWithGeoJson = Trip & {
  geojsonUrl: string
  geoJsonStringContent?: string
}

const tripSortKeyValues = [`vrn`, `riskScore`, `startedAt`, `finishedAt`] as const
export const tripSortKeysMap = new Map<TripSortKeysFE, TripSortKeys>([
  [tripSortKeyValues[0], tripSortKeyValues[0]],
  [tripSortKeyValues[1], tripSortKeyValues[1]],
  [tripSortKeyValues[2], tripSortKeyValues[2]],
  [tripSortKeyValues[3], tripSortKeyValues[3]],
])

export type TripSortKeys = (typeof tripSortKeyValues)[number]
export const tripSortKeyFeValues = tripSortKeyValues
export type TripSortKeysFE = (typeof tripSortKeyFeValues)[number]
